jQuery(document).ready(function ($) {
$(".slider").slick({
  slidesToShow: 5,
  slidesToScroll: 5,
  // normal options...
  infinite: false,
autoplay: true,
  // the magic
  responsive: [{

      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        infinite: true
      }

    }, {

      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        dots: true
      }

    }, {

      breakpoint: 300,
      settings: "unslick" // destroys slick

    }]
});

});